<template>
    <v-text-field
        v-model="text"
        :placeholder="placeholder"
        outlined
        :clearable="!readonly"
        v-disabled-icon-focus
        readonly
        hide-details
        v-slot:append
        @click:clear="picker = null"
        @click="menu = true"
        background-color="white"
        class="search-text-picker">
        <v-menu :disabled="readonly" v-model="menu" offset-y :close-on-content-click="false" left>
            <template v-if="!readonly" v-slot:activator="{ on }">
                <v-btn icon v-on="on" tabindex="-1">
                <v-icon>mdi-calendar</v-icon>
                </v-btn>
            </template>
            <v-date-picker
                :type="type"
                v-model="picker"
                @click="menu = false"
                :locale="locale"
                :color="color"
                :landscape="landscape"
                :day-format="date => new Date(date).getDate()"
            />
        </v-menu>
    </v-text-field>
</template>
<script>
    import moment from 'moment';
    export default {
        props: {
            value: {
                type: String,
                default: new Date().toISOString().substr(0, 10)
            },
            // 読み取り専用
            readonly: {
                type:Boolean,
                default: false,
            },
            // 入力タイプ
            type: {
                type: String,
                default: "date"
            },
            // 言語
            locale: {
                type: String,
                default: "jp-ja"               
            },
            // プレースホルダー
            placeholder: {
                type: String,
                default: "年/月/日",
            },
            // テキストフィールドの表示形式
            displayFormat: {
                type: String,
                default: "YYYY/MM/DD",
            },           
            // 色
            color: {
                type: String,
                default: "teal accent-4"
            },
            // 水平表示
            landscape: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                menu: false,
                text: null,
            };
        },
        computed: {
            picker: {
                get() {
                    // 表示日付フォーマット
                    this.text = this.value ? moment(this.value).format(this.displayFormat): this.picker = null;
                    return this.value;
                },
                set(val) {
                    this.menu = false;
                    this.$emit("input", val);
                }
            }
        }
    };
</script>
<style scoped>
    .search-text-picker::v-deep input {
        font-size: 1.5rem !important;
    }
    
    ::v-deep .search-text-picker {
        min-width: 165px !important;
    }
    
    .search-text-picker::v-deep .v-input__icon--clear {
        margin: -11px 8px 0px 0px !important;
    }
    
    .search-text-picker::v-deep .v-input__append-inner > .v-btn {
        width: 9px !important;
        margin-top: -22px;
    }
    .search-text-picker::v-deep .v-input__append-inner > .v-btn:before {
        background-color: transparent !important;
    }
        
    .search-text-picker ::v-deep .v-input__slot{
        height: 36px !important;
        min-height: 30px !important;
    }
    
    .mdi-calendar {
        padding-bottom: 10px;
    }
    
</style>